import EnumClass, { build } from '../EnumClass';
import data, { AuthProviderId, AuthProviderData } from './data';
import * as Translations from './translations';

export class AuthProvider extends EnumClass<AuthProviderId, AuthProviderData> {
  public get getName() {
    return Translations.name[this.id];
  }
}

export const {
  list: AUTH_PROVIDERS,
  getById: getAuthProviderById,
  codec: AuthProviderCodec,
  marshaller: AuthProviderMarshaller,
} = build<AuthProviderId, AuthProviderData, AuthProvider>('AuthProviderEnum', data, AuthProvider);
